<template>
  <div
    :style="{ backgroundImage: 'url(' + bg + ')', backgroundPosition: 'center' }"
  >
    <v-container grid-list-lg>
      <v-layout wrap>
        <v-flex sm4 v-for="(author, i) in authors" :key="i">
          <v-card
            :to="author.link"
          >
            <v-card-media
              contain
              :src="author.media"
              height="20em"
            >
            </v-card-media>
            <v-card-title class="text-md-center purple--text">
              <div style="margin: 0 auto">{{ author.title }}</div>
            </v-card-title>
            <v-card-text class="text-md-center">
              {{ author.text }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Lecturers from '@/server/lecturers'
export default {
  data () {
    return {
      bg: require('@/assets/bg/water_6.png'),
      authors: Lecturers.items
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dashboard/authors/index.vue